// This file was generated by "make codegen/iam". DO NOT EDIT.

import { GET_BUNDLE as ACTION_CNQUERY_EXPLORER_QUERYHUB_GETBUNDLE } from "~/lib/iam/actions/cnquery/explorer/QueryHub/GetBundle/action";
import { GET_MQUERY as ACTION_MONDOO_POLICY_REGISTRY_GETMQUERY } from "~/lib/iam/actions/mondoo/policy/Registry/GetMquery/action";
import { GET_RESOURCES_DATA as ACTION_CNQUERY_EXPLORER_RESOURCESEXPLORER_GETRESOURCESDATA } from "~/lib/iam/actions/cnquery/explorer/ResourcesExplorer/GetResourcesData/action";
import { LIST_CONTENT_CATEGORIES as ACTION_MONDOO_POLICY_REGISTRY_LISTCONTENTCATEGORIES } from "~/lib/iam/actions/mondoo/policy/Registry/ListContentCategories/action";
import { LIST_CONTENT_PLATFORMS as ACTION_MONDOO_POLICY_REGISTRY_LISTCONTENTPLATFORMS } from "~/lib/iam/actions/mondoo/policy/Registry/ListContentPlatforms/action";
import { LIST_MQUERIES as ACTION_MONDOO_POLICY_REGISTRY_LISTMQUERIES } from "~/lib/iam/actions/mondoo/policy/Registry/ListMqueries/action";
import { LIST_RESOURCES as ACTION_CNQUERY_EXPLORER_RESOURCESEXPLORER_LISTRESOURCES } from "~/lib/iam/actions/cnquery/explorer/ResourcesExplorer/ListResources/action";
import { SEARCH_CONTENT as ACTION_MONDOO_POLICY_REGISTRY_SEARCHCONTENT } from "~/lib/iam/actions/mondoo/policy/Registry/SearchContent/action";
import { SET_BUNDLE as ACTION_CNQUERY_EXPLORER_QUERYHUB_SETBUNDLE } from "~/lib/iam/actions/cnquery/explorer/QueryHub/SetBundle/action";
import { VALIDATE_BUNDLE as ACTION_CNQUERY_EXPLORER_QUERYHUB_VALIDATEBUNDLE } from "~/lib/iam/actions/cnquery/explorer/QueryHub/ValidateBundle/action";

export const allowedActions = [
  ACTION_CNQUERY_EXPLORER_QUERYHUB_GETBUNDLE,
  ACTION_CNQUERY_EXPLORER_QUERYHUB_SETBUNDLE,
  ACTION_CNQUERY_EXPLORER_QUERYHUB_VALIDATEBUNDLE,
  ACTION_CNQUERY_EXPLORER_RESOURCESEXPLORER_GETRESOURCESDATA,
  ACTION_CNQUERY_EXPLORER_RESOURCESEXPLORER_LISTRESOURCES,
  ACTION_MONDOO_POLICY_REGISTRY_GETMQUERY,
  ACTION_MONDOO_POLICY_REGISTRY_LISTCONTENTCATEGORIES,
  ACTION_MONDOO_POLICY_REGISTRY_LISTCONTENTPLATFORMS,
  ACTION_MONDOO_POLICY_REGISTRY_LISTMQUERIES,
  ACTION_MONDOO_POLICY_REGISTRY_SEARCHCONTENT,
] as const;
